<!--
This is a component that is loaded when a user clicks or has the shareable link
for a pass. It contains the logic what component to load for a specific user type.
-->
<template>
	<div>
		<div>
			<div class="nav-container">
				<nav class="navbar sticky-top">
					<div class="branding">
						<a class="navbar-brand" href="/">YeyPass</a>
						<p>Your secured identity pass in the real world.</p>
					</div>
					<div v-if="loggedInPerson !== ''">
						<h4>Hi, {{ loggedInPerson }}</h4>
						<div class="public-dashboard-link">
              <a href="/dashboard">Dashboard</a>
            </div>
					</div>
					<div v-else id="what-link">
						<a href="#">What's this?</a>
					</div>
				</nav>
			</div>

			<router-view
        :isLoggedIn="isLoggedIn"
        :linkId="linkId"
        :userId="userId"
        :accountType="accountType"
        :goToLogin="goToLogin"
        :goToVerifyAccount="goToVerifyAccount"
				:loggedInPerson="loggedInPerson"
				:inviteToken="inviteToken">
				<!-- load children -->
			</router-view>
		</div>
	</div>
</template>

<script>
import '@/assets/styles/public.css'

import Loader from '@/components/common/Loader'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
	components: { Loader },
	data() {
    return {
      linkId: this.$route.params.link_id,
      userId: auth.getUserId(),
			accountType: auth.getAccountType(),
			loggedInPerson: '',
			errorMessage: '',
			inviteToken: '',
			requestInProgress: true,
      isLoggedIn: false
    }
  },
	mounted() {
		this.inviteToken = this.$route.query.t
		this.checkIfUserIsLoggedIn()
  },
	methods: {
    checkIfUserIsLoggedIn() {
      if(this.userId !== null) {
        this.isLoggedIn = true
        this.loggedInPerson = this.accountType === 'business' ?
          auth.getCompanyName() : auth.getUname()
      } else {
        this.isLoggedIn = false
      }
    },
    goToLogin(originUrl) {
      auth.logout()
			let route = '/login'
			if(originUrl !== '' || originUrl !== undefined) {
				route = `/login?page_origin=${originUrl}`
			}
			this.$router.push(route)
    },
    goToVerifyAccount(originUrl) {
			let route = '/dashboard/verify-account'
			if(originUrl !== '' || originUrl !== undefined) {
				route = `/dashboard/verify-account?page_origin=${originUrl}`
			}
      this.$router.push(route)
    }
	}
}
</script>



// WEBPACK FOOTER //
// src/containers/share/ShareView.vue